import React, { useState } from 'react'
import { differenceInCalendarDays, isValid } from 'date-fns'
import { Button } from 'views/components'
import { formatStandard } from 'utils/date'
import AllocationModal from '../Modal/AllocationModal/AllocationModal'
import SuspenseNote from '../SuspenseNote/SuspenseNote'
import { SuspenseReference } from '../../types'
import styles from './ViewSuspenseAccount.module.scss'

interface ViewUnallocatedReferenceProps {
  currentReference?: SuspenseReference | null
  closeReference: () => void
}

const getDaysUnallocated = (dateReceived?: string): string | undefined => {
  const received = new Date(dateReceived ?? '')
  if (!isValid(received)) return undefined
  const days = Math.max(0, differenceInCalendarDays(new Date(), received))
  return `${days} ${days === 1 ? 'day' : 'days'} unallocated`
}

const ViewUnallocatedReference = ({
  currentReference,
  closeReference,
}: ViewUnallocatedReferenceProps): React.ReactElement => {
  const [isOpen, setIsOpen] = useState(false)
  const daysUnallocated = getDaysUnallocated(currentReference?.dateReceived)

  return (
    <div>
      <div className={styles.status}>
        {daysUnallocated && <strong>{daysUnallocated}</strong>}
        <span>Received {formatStandard(currentReference?.dateReceived)}</span>
      </div>
      <div className={styles.actions}>
        <Button onClick={() => setIsOpen(true)}>Allocate to wallet</Button>
        {/* Placeholder until refunds have a back-end flow. */}
        {/* <Button secondary disabled title="Refunds aren't available yet">
          Flag for refund
        </Button> */}
      </div>
      <div className={styles.notes}>
        <span className={styles.eyebrow}>Notes</span>
        <SuspenseNote
          multiline={true}
          placeholder="What have you tried? Who did you contact?"
          txId={currentReference?.txId}
          note={currentReference?.notes}
          updatedBy={currentReference?.notesUpdatedBy}
          updatedAt={currentReference?.notesUpdatedAt}
        />
      </div>
      <AllocationModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        currentReference={currentReference}
        onAllocated={closeReference}
      />
    </div>
  )
}

export default ViewUnallocatedReference
